import './Listing';
import './Form';
import DeleteEmployeeContractForm from "../employee-contract/modals/DeleteEmployeeContractForm.vue";

Vue.component('delete-employee-contract-form', DeleteEmployeeContractForm);



// WEBPACK FOOTER //
// ./resources/assets/admin/js/employee-contract/index.js